import { getPeriodLength } from "./ClockPeriod";

const clockRegex = /PT(\d+)M(\d+)(?:\.(\d+))?S/;

export function convertClock(clock) {
  const match = clock.match(clockRegex);
  if (!match || !match[1] || !match[2]) {
    return "00:00";
  }
  const clockDisplay = match[1].padStart(2, 0) + ":" + match[2].padStart(2, 0);
  return clockDisplay;
}

export function convertClockWithMs(clock) {
  const match = clock.match(clockRegex);
  if (!match || !match[1] || !match[2]) {
    return ["00:00", "000"];
  }
  const clockDisplay = match[1].padStart(2, 0) + ":" + match[2].padStart(2, 0);
  return [clockDisplay, !!match[3] ? match[3].padStart(3, 0) : "000"];
}

export function convertDisplayTimeToDataTime(displayTime) {
  let clockParts = displayTime.split(":");
  return "PT" + parseInt(clockParts[0]) + "M" + parseInt(clockParts[1]) + "S";
}

export function convertDisplayTimeToDataTimeWithMs(displayTime, clockMs) {
  if (!displayTime) return null;
  let clockParts = displayTime.split(":");
  return "PT" + parseInt(clockParts[0]) + "M" + parseInt(clockParts[1]) + "S";
}

export function convertEventTimeClock({ clock, periodId, fixtureProfile, sport }) {
  const displayTime = convertClock(clock);
  const { periodLength } = fixtureProfile;

  if (sport !== "handball" || (periodId === 1 || periodId >= fixtureProfile.initialExtraPeriodId)) {
    return displayTime;
  }

  const [minutes, seconds] = displayTime?.split(":");
  return `${parseInt(minutes, 10) + periodLength}:${seconds}`;
}

export function convertToFullDisplayTime({
  clock,
  periodId,
  fixtureProfile,
  sport,
}) {
  const { periodLength } = fixtureProfile;

  if (sport !== "handball" || (periodId === 1 || periodId >= fixtureProfile.initialExtraPeriodId)) {
    return clock;
  }

  const [minutes, seconds] = clock?.split(":");
  return `${parseInt(minutes, 10) - periodLength}:${seconds}`;
}
